module.exports = __webpack_public_path__ + "static/img/impacta.cd4d5a43.svg";